@if (condition) {
  <div class="string2-condition-editor" [formGroup]="detailsFormGroup">
    <div class="row">
      <mat-form-field class="flex-grow" appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.masterdata.string2"></sc-dictionary-label>
        </mat-label>
        <input matInput formControlName="string2" name="string2" maxlength="255"
          [maxlength]="255">
        </mat-form-field>
      </div>
    </div>
  }
